import { IInvoice } from 'features/billing/invoices/invoicesTypes';
import { paymentsClient } from '../axiosInstance';
import { IFetchUpcomingInvoiceParams } from 'features/billing/upcomingInvoice/upcomingInvoiceTypes';

const invoicesURL = process.env.REACT_APP_PAYMENTS_API + '/invoices'

export const fetchInvoicesBySubscriptionId = async (subscriptionId: string) => {
    return await paymentsClient.get<IInvoice[]>(invoicesURL + `/subscriptions/${subscriptionId}`);
}

export const fetchLatestInvoiceBySubscriptionId = async (subscriptionId: string) => {
    return await paymentsClient.get<IInvoice>(invoicesURL + `/subscriptions/${subscriptionId}/latest`);
}

export const patchPatLatestInvoiceBySubscriptionId = async (subscriptionId: string) => {
    return await paymentsClient.patch<IInvoice>(invoicesURL + `/subscriptions/${subscriptionId}/latest/pay`);
}

export const fetchUpcomingInvoice = async (params: IFetchUpcomingInvoiceParams) => {
    const priceIdQuery = `priceId=${params.priceId}`;
    const quantityQuery = `quantity=${params.quantity}`;
    const couponIdQuery = params.couponId ? `couponId=${params.couponId}` : '';

    const addressQuery = Object.entries(params.address ?? {})
        .map(([key, val]) => `address.${key}=${encodeURIComponent(val)}`)
        .join('&');

    const taxIdsQuery = (params.taxIds ?? [])
        .flatMap((tax, idx) => [
            `taxIds[${idx}].id=${encodeURIComponent(tax.id)}`,
            `taxIds[${idx}].type=${encodeURIComponent(tax.type)}`
        ])
        .join('&');

    const queryString = [
        priceIdQuery,
        quantityQuery,
        couponIdQuery,
        addressQuery,
        taxIdsQuery 
    ]
        .filter(Boolean)
        .join('&');

    return await paymentsClient.get<IInvoice>(invoicesURL + `/upcoming?${queryString}`);
}

export const fetchUpcomingInvoiceForSubscription = async (subscriptionId: string, priceId: string, quantity: number) => {
    const priceIdQuery = `priceId=${priceId}&`;
    const quantityQuery = `quantity=${quantity}&`;

        const queryString = [
        priceIdQuery,
        quantityQuery,
    ]
        .filter(Boolean)
        .join('&');

    return await paymentsClient.get<IInvoice>(invoicesURL + `/upcoming/subscriptions/${subscriptionId}?${queryString}`);
}
